export const AMENITY_KEYS = [
  'wifi',
  'restroom',
  'restaurants',
  'shopping',
  'covered_parking',
  'security_camera',
  'valet_parking',
  '24_7',
  'wheelchair',
  'cafe',
  'atm',
  'pharmacy',
  'convenience_store',
  'gas_station',
  'hotel',
  'gym',
  'park',
  'bank',
  'parking',
] as const;

export type AmenityKey = typeof AMENITY_KEYS[number];
